namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class PurchasePackagesGrid extends Serenity.EntityGrid<PurchasePackagesRow, any> {
        protected getColumnsKey() { return PurchasePackagesColumns.columnsKey; }
        protected getDialogType() { return PurchasePackagesDialog; }
        protected getIdProperty() { return PurchasePackagesRow.idProperty; }
        protected getInsertPermission() { return PurchasePackagesRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchasePackagesRow.localTextPrefix; }
        protected getService() { return PurchasePackagesService.baseUrl; }
        protected getIsActiveProperty() { return PurchasePackagesRow.isActiveProperty; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}
